import { useParams } from "@tanstack/react-router"
import { useGetCurrentTenantQuery } from "./api"

export default () => {
  const { tenantSlug } = useParams({ from: "/(user)/t/$tenantSlug" })
  const { data: tenant, isLoading } = useGetCurrentTenantQuery()

  return {
    tenantSlug,
    tenant,
    isLoading,
  }
}
